import StringFormat from "string-format";
import { ApiConstant, KeyConstant } from "@/const";
import { HumpsUtils, StorageUtils } from "@/utils";
import { ResponseDataList, ResponseUserType } from "@/types/service";
import { Nullable } from "@/types/common";
import GlobalApi, { ApiResponse } from "./config/api.config";

export type PayloadChangePasswordType = {
  password: string;
  newPassword: string;
  confirmPassword: string;
};

export type PayloadUpdateUserType = {
  name: Nullable<string>;
  email: Nullable<string>;
  phoneNumber: Nullable<string>;
  department: Nullable<string>;
  unit: Nullable<string>;
  avatar?: Nullable<string>;
};

const formatResponseData = (response?: ResponseDataList<ResponseUserType>) => {
  return {
    ...response,
    data: response?.data?.map((item: ResponseUserType) => {
      return {
        ...item,
        createdAt: (item?.created && new Date(item?.created)) || undefined,
      };
    }),
  };
};

export const getUser = async (uid: string) => {
  const response = await GlobalApi.toCamel().get<ApiResponse<ResponseUserType>>(
    StringFormat(ApiConstant.GET_USER, { uid }),
  );
  if (response.ok && response.data) return response.data.data;
  throw response;
};

export const updateUser = async (payload: PayloadUpdateUserType) => {
  const uid = StorageUtils.getItem<string>(KeyConstant.KEY_UID) || "";
  const response = await GlobalApi.toCamel().put<ApiResponse<ResponseUserType>>(
    StringFormat(ApiConstant.PUT_USER_UPDATE, { uid }),
    HumpsUtils.decamelizeKeys(payload),
  );
  if (response.ok && response.data) return response.data.data;
  throw response;
};

export const changePassword = async (payload: PayloadChangePasswordType) => {
  const response = await GlobalApi.toCamel().put<ApiResponse<null>>(
    ApiConstant.PUT_USER_CHANGE_PASSWORD,
    HumpsUtils.decamelizeKeys(payload),
  );
  if (response.ok && response.data) return response.data.data;
  throw response;
};

export const getUsers = async (payload: any) => {
  const response = await GlobalApi.toCamel().get<ResponseDataList<ResponseUserType>>(
    ApiConstant.GET_USER_LIST,
    payload,
  );
  if (response.ok && response.data) return formatResponseData(response.data);
  throw response;
};

export const registerUser = async (payload: PayloadUpdateUserType) => {
  const response = await GlobalApi.toCamel().post<ApiResponse<ResponseUserType>>(
    StringFormat(ApiConstant.REGISTER_USER),
    HumpsUtils.decamelizeKeys(payload),
  );
  if (response.ok && response.data) return response.data.data;
  throw response;
};

export const resetPassword = async (uid: string) => {
  const response = await GlobalApi.toCamel().get<ApiResponse<ResponseUserType>>(
    StringFormat(ApiConstant.RESET_PASSWORD, { uid }),
  );
  if (response.ok && response.data) return response.data.data;
  throw response;
};

export const getExternalUsers = async (payload: any) => {
  const response = await GlobalApi.toCamel().get<ResponseDataList<ResponseUserType>>(
    ApiConstant.GET_EXTERNAL_USER_LIST,
    payload,
  );
  if (response.ok && response.data) return formatResponseData(response.data);
  throw response;
};
